import { render, staticRenderFns } from "./ActivityAdmission.vue?vue&type=template&id=5fd76f45&scoped=true&"
import script from "./ActivityAdmission.vue?vue&type=script&lang=js&"
export * from "./ActivityAdmission.vue?vue&type=script&lang=js&"
import style0 from "./ActivityAdmission.vue?vue&type=style&index=0&id=5fd76f45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd76f45",
  null
  
)

export default component.exports